<app-main-layout>
  <app-orders-page></app-orders-page>
</app-main-layout>
